<template>
  <div class="container">
    <h1 class="text-center">国标麻将算番工具</h1>
    <form class="row" @submit.prevent="calculate">
      <div class="col-sm">
        <div class="form-group row" @click="focusing = 'hand'">
          <label class="col-sm-2 col-form-label col-form-label-sm">手牌</label>
          <div class="mahjong-tiles-area col-sm-10" :class="{focusing: focusing === 'hand'}"
            @dragover.prevent @drop="event => drop('hand', event)">
            <div
              v-for="(tile, index) in hand" :key="index"
              class="mahjong-tile" :class="'mahjong-tile-' + tile"
              @click="removeFromHand(index)"
            ></div>
          </div>
        </div>
        <div class="form-group row" @click="focusing = 'chow'">
          <label class="col-sm-2 col-form-label col-form-label-sm">吃</label>
          <div class="mahjong-tiles-area col-sm-10" :class="{focusing: focusing === 'chow'}"
            @dragover.prevent @drop.prevent="event => drop('chow', event)">
            <template v-for="(tile, index) in chows">
              <div :key="index * 3"
                class="mahjong-tile" :class="'mahjong-tile-' + (tile - 1)"
                @click="removeFromChows(index)"
              ></div>
              <div :key="index * 3 + 1"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromChows(index)"
              ></div>
              <div :key="index * 3 + 2"
                class="mahjong-tile" :class="'mahjong-tile-' + (tile + 1)"
                @click="removeFromChows(index)"
              ></div>
            </template>
          </div>
        </div>
        <div class="form-group row" @click="focusing = 'pung'">
          <label class="col-sm-2 col-form-label col-form-label-sm">碰</label>
          <div class="mahjong-tiles-area col-sm-10" :class="{focusing: focusing === 'pung'}"
            @dragover.prevent @drop.prevent="event => drop('pung', event)">
            <template v-for="(tile, index) in pungs">
              <div :key="index * 3"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromPungs(index)"
              ></div>
              <div :key="index * 3 + 1"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromPungs(index)"
              ></div>
              <div :key="index * 3 + 2"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromPungs(index)"
              ></div>
            </template>
          </div>
        </div>
        <div class="form-group row" @click="focusing = 'exposed-kong'">
          <label class="col-sm-2 col-form-label col-form-label-sm">明杠</label>
          <div class="mahjong-tiles-area col-sm-10" :class="{focusing: focusing === 'exposed-kong'}"
            @dragover.prevent @drop.prevent="event => drop('exposed-kong', event)">
            <template v-for="(tile, index) in exposedKongs">
              <div :key="index * 4"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromExposedKongs(index)"
              ></div>
              <div :key="index * 4 + 1"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromExposedKongs(index)"
              ></div>
              <div :key="index * 4 + 2"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromExposedKongs(index)"
              ></div>
              <div :key="index * 4 + 3"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromExposedKongs(index)"
              ></div>
            </template>
          </div>
        </div>
        <div class="form-group row" @click="focusing = 'concealed-kong'">
          <label class="col-sm-2 col-form-label col-form-label-sm">暗杠</label>
          <div class="mahjong-tiles-area col-sm-10" :class="{focusing: focusing === 'concealed-kong'}"
            @dragover.prevent @drop.prevent="event => drop('concealed-kong', event)">
            <template v-for="(tile, index) in concealedKongs">
              <div :key="index * 4"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromConcealedKongs(index)"
              ></div>
              <div :key="index * 4 + 1"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromConcealedKongs(index)"
              ></div>
              <div :key="index * 4 + 2"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromConcealedKongs(index)"
              ></div>
              <div :key="index * 4 + 3"
                class="mahjong-tile" :class="'mahjong-tile-' + tile"
                @click="removeFromConcealedKongs(index)"
              ></div>
            </template>
          </div>
        </div>
        <div class="form-group row" @click="focusing = 'wait-tile'">
          <label class="col-sm-2 col-form-label col-form-label-sm">和牌</label>
          <div class="mahjong-tiles-area col-sm-10 single-tile" :class="{focusing: focusing === 'wait-tile'}"
            @dragover.prevent @drop.prevent="event => drop('wait-tile', event)">
            <div v-if="waitTile != null"
              class="mahjong-tile" :class="'mahjong-tile-' + waitTile"
              @click="removeWaitTile"
            ></div>
          </div>
        </div>
      </div>
      <div class="col-sm">
        <div class="tiles-group">
          <div
            v-for="n in 34" :key="n"
            class="mahjong-tile" :class="'mahjong-tile-' + (n - 1)"
            draggable
            @dragstart="event => dragStart(event, n - 1)"
            @click="event => chooseTile(n - 1)"
          ></div>
        </div>
        <br>
        <div class="form-group">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="isSelfDrawn" v-model="isSelfDrawn" :value="false" checked>
            <label class="form-check-label">点和</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" name="isSelfDrawn" v-model="isSelfDrawn" :value="true">
            <label class="form-check-label">自摸</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="isFourthTile">
            <label class="form-check-label">和绝张</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="isKong">
            <label class="form-check-label">{{ isSelfDrawn ? '杠上开花' : '抢杠和' }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" v-model="isLastTile">
            <label class="form-check-label">{{ isSelfDrawn ? '妙手回春' : '海底捞月' }}</label>
          </div>
        </div>
        <div class="from-group">
          <label>圈风</label>
          <select class="form-control" v-model.number="prevalentWind">
            <option value="27">东</option>
            <option value="28">南</option>
            <option value="29">西</option>
            <option value="30">北</option>
          </select>
        </div>
        <div class="from-group">
          <label>门风</label>
          <select class="form-control" v-model.number="seatWind">
            <option value="27">东</option>
            <option value="28">南</option>
            <option value="29">西</option>
            <option value="30">北</option>
          </select>
        </div>
        <div class="form-group">
          <label>花牌</label>
          <input class="form-control" type="number" v-model.number="flowers" min="0" max="8">
        </div>
        <button type="submit" class="btn btn-primary">算番</button>
      </div>
    </form>
    <output v-if="result != null">
      <table>
        <thead>
          <tr>
            <th>番种</th>
            <th>分数</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fan, index) in result.fans.filter(fan => fan.name !== '花牌')" :key="index">
            <td>{{ fan.name }}</td>
            <td class="text-right">{{ fanMap[fan.name] }}</td>
          </tr>
          <tr v-if="result.fans.some(fan => fan.name === '花牌')">
            <td>花牌</td>
            <td class="text-right">1 &times; {{ result.fans.filter(fan => fan.name === '花牌').length }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>总计</td>
            <td class="text-right">{{ result.score }}</td>
          </tr>
        </tfoot>
      </table>
    </output>
  </div>
</template>

<script>
import {Chow, ExposedPung, ExposedKong, ConcealedKong, MahjongHand, fanMap} from 'mahjong-scoring'

export default {
  name: 'mahjong-calculator',
  data() {
    return {
      hand: [],
      chows: [],
      pungs: [],
      exposedKongs: [],
      concealedKongs: [],
      waitTile: null,
      isSelfDrawn: false,
      isFourthTile: false,
      isKong: false,
      isLastTile: false,
      prevalentWind: 27,
      seatWind: 27,
      flowers: 0,
      fanMap,
      result: null,
      focusing: null
    }
  },
  methods: {
    dragStart(event, n) {
      event.dataTransfer.setData('text/plain', JSON.stringify({tile: n}))
      event.dataTransfer.dropEffect = 'copy'
    },
    drop(area, event) {
      let tile = JSON.parse(event.dataTransfer.getData('text')).tile
      this[{
        hand: 'addToHand',
        chow: 'addToChows',
        pung: 'addToPungs',
        'exposed-kong': 'addToExposedKongs',
        'concealed-kong': 'addToConcealedKongs',
        'wait-tile': 'setWaitTile'
      }[area]](tile)
    },
    addToHand(tile) {
      this.hand.push(tile)
      this.hand.sort((x, y) => x - y)
      this.focusing = 'hand'
    },
    removeFromHand(index) {
      this.hand.splice(index, 1)
    },
    addToChows(tile) {
      this.chows.push(tile)
      this.chows.sort((x, y) => x - y)
      this.focusing = 'chow'
    },
    removeFromChows(index) {
      this.chows.splice(index, 1)
    },
    addToPungs(tile) {
      this.pungs.push(tile)
      this.pungs.sort((x, y) => x - y)
      this.focusing = 'pung'
    },
    removeFromPungs(index) {
      this.pungs.splice(index, 1)
    },
    addToExposedKongs(tile) {
      this.exposedKongs.push(tile)
      this.exposedKongs.sort((x, y) => x - y)
      this.focusing = 'exposed-kong'
    },
    removeFromExposedKongs(index) {
      this.exposedKongs.splice(index, 1)
    },
    addToConcealedKongs(tile) {
      this.concealedKongs.push(tile)
      this.concealedKongs.sort((x, y) => x - y)
      this.focusing = 'concealed-kong'
    },
    removeFromConcealedKongs(index) {
      this.concealedKongs.splice(index, 1)
    },
    setWaitTile(tile) {
      this.waitTile = tile
      this.focusing = 'wait-tile'
    },
    removeWaitTile() {
      this.waitTile = null
    },
    chooseTile(tile) {
      if (this.focusing) {
        this[{
          hand: 'addToHand',
          chow: 'addToChows',
          pung: 'addToPungs',
          'exposed-kong': 'addToExposedKongs',
          'concealed-kong': 'addToConcealedKongs',
          'wait-tile': 'setWaitTile'
        }[this.focusing]](tile)
      }
    },
    calculate() {
      let hand = new MahjongHand({
        tiles: this.hand,
        waitTile: this.waitTile,
        chows: this.chows.map(tile => new Chow(tile)),
        pungs: this.pungs.map(tile => new ExposedPung(tile)),
        exposedKongs: this.exposedKongs.map(tile => new ExposedKong(tile)),
        concealedKongs: this.concealedKongs.map(tile => new ConcealedKong(tile)),
        flowers: this.flowers,
        prevalentWind: this.prevalentWind,
        seatWind: this.seatWind,
        isSelfDrawn: this.isSelfDrawn,
        isFourthTile: this.isFourthTile,
        isKong: this.isKong,
        isLastTile: this.isLastTile
      })
      this.result = hand.getScore()
    }
  }
}
</script>

<style lang="less" src="../mahjong-tiles.less"></style>
<style scoped lang="less">
  .mahjong-tile {
    width: 2rem;
    height: 2.5rem;
  }
  .mahjong-tiles-area {
    display: flex;
    flex-wrap: wrap;
    min-height: 3.1rem;
    padding: 0.3rem;
    outline: 1px dashed black;
    &.single-tile {
      width: 2.6rem;
    }
    &.focusing {
      outline-color: red;
    }
  }
  .tiles-group {
    display: flex;
    flex-wrap: wrap;
    width: 18rem;
  }
</style>
